<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsSlider',
  
})
</script>
<template>
  <div class="tlbs-slider-container">
    <t-slider
      v-model="initVal"
      class="tlbs-slider"
      v-bind="inputAttrs"
      @change="onChange"
    />
  </div>
</template>

<script lang="ts" setup name="TlbsSlider">

interface Props {
  modelValue: string | number;
  formatter?:  (arg1: string) => string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: 0,
  formatter: (val: string) => val,
});
const labelFormatter = ref((val: string) => val);
const emit = defineEmits<(e: 'update:modelValue' | 'change', value: string | number | boolean | object | []) => void>();
const attrs = useAttrs();
// class 和 id不透出
const inputAttrs = computed(() => {
  const returnObj = {};
  for (const attr in attrs) {
    if (!['class', 'id'].includes(attr)) {
      returnObj[attr] = attrs[attr];
    }
  }
  return returnObj;
});
const initVal = ref(props.modelValue);
watchEffect(() => {
  if (typeof props.formatter !== 'function') {
    labelFormatter.value = (val: string) => val;
  }
});

watch(() => props.modelValue, (newVal) => {
  initVal.value = newVal;
  changeLabel(labelFormatter.value(String(initVal.value)));
  emit('update:modelValue', newVal);
});
const changeLabel = (content: string) => {
  const sliderBtn = document.querySelector('.t-slider__button');
  sliderBtn?.setAttribute('model-value', content);
};
onMounted(() => {
  changeLabel(labelFormatter.value(String(initVal.value)));
});
const onChange = (value: string | number) => {
  initVal.value = value;
  changeLabel(labelFormatter.value(String(initVal.value)));
  emit('update:modelValue', value);
  emit('change', value);
};

</script>

